
import { defineComponent, reactive, toRefs } from "vue";
import EduExperience from "./../updateCv/eduExperience.vue";
import { Delete, CirclePlus, EditPen } from "@element-plus/icons-vue";
import { recruitService } from "@/api";
import utils from "@/utils/util";
import { ElMessage } from "element-plus/lib/components";
export default defineComponent({
  props: {
    detail: Object,
  },
  components: {
    EduExperience,
  },
  setup(props) {
    const state = reactive<{
      autoSize: any;
      detail: any;
      diaLogTitle: string;
      dialogVisible: boolean;
      eduExpList: any;
    }>({
      autoSize: { minRows: 4, maxRows: 6 },
      detail: props.detail,
      dialogVisible: false,
      diaLogTitle: "编辑教育经历",
      eduExpList: [],
    });
    function edit(name: string, obj?: any) {
      if (obj) {
        const daterange = [
          utils.dateFm(obj.startDate, "YYYY-MM-DD"),
          utils.dateFm(obj.endDate, "YYYY-MM-DD"),
        ];
        obj["guid"] = utils.guid();
        const target = JSON.parse(
          JSON.stringify(Object.assign(obj, { daterange: daterange }))
        );
        state.eduExpList = [target];
      } else {
        state.eduExpList = [];
      }
      state.diaLogTitle = name;
      state.dialogVisible = true;
    }
    function closeDialog() {
      state.dialogVisible = false;
    }
    function save(body: any) {
      state.detail = Object.assign(state.detail, body);
      closeDialog();
    }
    function deleteInfo(obj: any, index: number) {
      recruitService.user
        .deleteEdu(obj)
        .then(() => {
          ElMessage.success("删除成功！");
          state.detail.eduExpList.splice(index, 1);
        })
        .catch((val) => {
          if (val.isHttpStatus) {
            console.log(val.statusText);
          } else {
            ElMessage.error(val.message || "错误");
          }
        });
    }
    return {
      ...toRefs(state),
      CirclePlus,
      Delete,
      EditPen,
      edit,
      deleteInfo,
      closeDialog,
      save,
    };
  },
});
